import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ProfileEditPage from './profile/ProfileEditPage';
import OperatorsLimitsPage from '../operatorsLimits/OperatorsLimitsPage';

export default function SettingsProfilePage() {
  return (
    <Routes>
      <Route path='profile' element={<ProfileEditPage />} />
      <Route path='limits' element={<OperatorsLimitsPage />} />
    </Routes>
  );
}
